if (!customElements.get('ritual-floating-offer-cta')) {
  customElements.define('ritual-floating-offer-cta', class extends HTMLElement {
    connectedCallback() {
      this.offer = document.querySelector(this.dataset.offerSelector);
      this.product = document.querySelector('.product-information, [id^="ProductInformation-"]');
      const footerGroup = document.querySelector('.shopify-section-group-footer-group');
      this.footer = footerGroup?.closest('footer') || footerGroup || document.querySelector('body > footer');
      if (!this.offer || !this.product) return;
      this.hidden = false;
      this.productPassed = false;
      this.footerVisible = false;
      this.productObserver = new IntersectionObserver(([entry]) => {
        const passedBelowViewport = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        this.productPassed = passedBelowViewport;
        this.update();
      }, { threshold: 0 });
      this.productObserver.observe(this.product);
      if (this.footer) {
        this.footerObserver = new IntersectionObserver(([entry]) => {
          this.footerVisible = entry.isIntersecting;
          this.update();
        }, { threshold: 0 });
        this.footerObserver.observe(this.footer);
      }
      this.querySelector('button')?.addEventListener('click', () => {
        this.offer.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      });
    }
    disconnectedCallback() { this.productObserver?.disconnect(); this.footerObserver?.disconnect(); }
    update() { this.classList.toggle('is-visible', this.productPassed && !this.footerVisible); }
  });
}
